import { AppliedFacets, FacetOption } from '../../../../../../types/facets';

const INITIAL_COUNTER = 0;

const ignoreFacets = (facetsToIgnore: string[]) => (
  ([facetName]: [string, FacetOption]) => !facetsToIgnore.includes(facetName)
);

function reduceTotalLength(acc: any, [, amountOfSelectedOptions]: any): number {
  return acc + amountOfSelectedOptions.length;
}

const getAppliedFacetsCount = (appliedFacets: AppliedFacets, facetsToIgnore: string[] = []) =>
  Object
    .entries(appliedFacets)
    .filter(ignoreFacets(facetsToIgnore))
    .reduce(reduceTotalLength, INITIAL_COUNTER);


export default getAppliedFacetsCount;
